import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BlueButton } from "../../../components/attributes/Button";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  CONSTANT_LANGUAGE,
  RETURN_SHOSE_TIME,
  RETURN_TIME,
  TEXT_ALL_CHOOSE_1,
  TEXT_CHOOSE_AND_CUSTOMIZE,
  TEXT_CONVENIENT,
  TEXT_CREATE_ORDER,
  TEXT_DES_HOW_IT_WORKS_2,
  TEXT_DES_HOW_IT_WORKS_DESKTOP,
  TEXT_DES_HOW_IT_WORKS_IPAD,
  TEXT_DES_HOW_IT_WORKS_IPAD_2,
  TEXT_EASIER_AND_MORE_CONVENIENT,
  TEXT_EASY,
  TEXT_EASY_AND_CONVENIENT_ALL,
  TEXT_EASY_AND_CONVENTIENT,
  TEXT_HOW_IT_WORKS,
  TEXT_NO_SURPRIZE,
  TEXT_PRICES,
  TEXT_TRY_IT_ONCE,
  TEXT_WE_TAKE_CARE,
  TEXT_WE_TAKE_CARE_DESCRIPTION_ALL,
} from "../../../utils/useConstants";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_BODY_1_TEXT_LG,
  STYLE_BODY_1_TEXT_LG_TH,
  STYLE_BODY_4_REGULAR,
  STYLE_BUTTON_BLUE,
  STYLE_BUTTON_HIW,
  STYLE_DES_HOWITWORKS,
  STYLE_HEADING_2,
  STYLE_IMG_MB_HIW,
  STYLE_LINK_BLUE,
  STYLE_LINK_BLUE_NO_MX,
  STYLE_PADDING_WINDOWS,
  STYLE_SPACE_SECTION_HIW,
  STYLE_UNDERLINE_BLUE_24_16,
} from "../../../utils/useStyle";

const HomeHowItWorks = React.memo(() => {
  const navigate = useNavigate();
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();

  const img = [
    {
      img: "/images/customize.png",
      title: `${TEXT_CHOOSE_AND_CUSTOMIZE[language]}`,
      description1: `${TEXT_ALL_CHOOSE_1[language]}`,
    },
    {
      img: "/images/takecare.png",
      title: `${TEXT_WE_TAKE_CARE[language]}`,
      description1: (
        <div>
          {language === "TH" ? (
            <React.Fragment>
              เรา<span className="">รับประกัน</span>
              ว่าจะส่งคืนทุกออเดอร์ในวันถัดไป: เสื้อผ้าและเครื่องนอนภายใน{" "}
              {RETURN_TIME}:00 น. รองเท้าหรือออเดอร์รวมผ้ากับรองเท้าภายใน{" "}
              {RETURN_SHOSE_TIME}:00 น. สะดวกและรวดเร็ว!
              <span className=""> บริการไร้การสัมผัส</span>
              ของเราช่วยคุณประหยัดเวลา - คุณไม่ต้องรอการรับส่งคืนออเดอร์เลย!
            </React.Fragment>
          ) : (
            `We GUARANTEE next-day return for all orders: Laundry by ${RETURN_TIME}:00 noon, shoes or combined shoes & laundry orders by ${RETURN_SHOSE_TIME}:00 - fast & easy! Our service is fully CONTACTLESS to save your valuable time - you never need to wait for us, neither for pick up nor for return!`
          )}
        </div>
      ),
    },
    {
      img: "/images/convenient.png",
      title: `${TEXT_EASY_AND_CONVENTIENT[language]}`,
      description1: `${TEXT_EASY_AND_CONVENIENT_ALL[language]}`,
      description2: `${TEXT_EASIER_AND_MORE_CONVENIENT[language]}`,
    },
  ];

  return (
    <div className={` ${STYLE_PADDING_WINDOWS} my-5 md:my-13 `}>
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {TEXT_HOW_IT_WORKS[language]}
      </div>
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      <div
        className={`${STYLE_DES_HOWITWORKS(language)} pb-4 md:pb-6 leading-6`}
      >
        {isMobile ? (
          <React.Fragment>
            <div
              className={` ${
                language === CONSTANT_LANGUAGE.TH
                  ? ` xl:flex justify-center `
                  : ""
              } `}
            >
              <div className=" hidden md:block ">
                {TEXT_DES_HOW_IT_WORKS_DESKTOP[language]}
                <div>
                  <span className="">
                    <span>{TEXT_DES_HOW_IT_WORKS_2[language]}</span>
                    {language === "TH" && "ด้วย"}
                    <span
                      className={`${STYLE_LINK_BLUE}`}
                      onClick={() => {
                        navigate("/Pricing");
                      }}
                    >
                      {TEXT_PRICES[language]}
                    </span>
                    <span className="">{TEXT_NO_SURPRIZE[language]}</span>
                  </span>
                  {TEXT_TRY_IT_ONCE[language]}
                </div>
              </div>
              <div className=" block md:hidden ">
                {TEXT_DES_HOW_IT_WORKS_IPAD[language]}{" "}
                <span>
                  {TEXT_DES_HOW_IT_WORKS_IPAD_2[language]}
                  <span>{TEXT_DES_HOW_IT_WORKS_2[language]}</span>{" "}
                  <span
                    className={`${STYLE_LINK_BLUE_NO_MX}`}
                    onClick={() => {
                      navigate("/Pricing");
                    }}
                  >
                    {TEXT_PRICES[language]}
                  </span>{" "}
                  <span className="">{TEXT_NO_SURPRIZE[language]}</span>
                  {TEXT_TRY_IT_ONCE[language]}
                </span>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div
              className={` ${
                language === CONSTANT_LANGUAGE.TH
                  ? ` xl:flex justify-center `
                  : ""
              } `}
            >
              <div className=" hidden lg:block ">
                {TEXT_DES_HOW_IT_WORKS_DESKTOP[language]}
                <div>
                  <span className="">
                    <span>{TEXT_DES_HOW_IT_WORKS_2[language]}</span>
                    {language === "TH" && "ด้วย"}
                    <span
                      className={`${STYLE_LINK_BLUE}`}
                      onClick={() => {
                        navigate("/Pricing");
                      }}
                    >
                      {TEXT_PRICES[language]}
                    </span>
                    <span className="">{TEXT_NO_SURPRIZE[language]}</span>
                  </span>
                  {TEXT_TRY_IT_ONCE[language]}
                </div>
              </div>
              <div className=" block lg:hidden ">
                {TEXT_DES_HOW_IT_WORKS_IPAD[language]}
                <div>
                  {TEXT_DES_HOW_IT_WORKS_IPAD_2[language]}
                  <span>{TEXT_DES_HOW_IT_WORKS_2[language]}</span>
                  <span
                    className={`${STYLE_LINK_BLUE}`}
                    onClick={() => {
                      navigate("/Pricing");
                    }}
                  >
                    {TEXT_PRICES[language]}
                  </span>
                  {TEXT_TRY_IT_ONCE[language]}
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
      <div className=" grid grid-cols-1 gap-4 md:grid-cols-3 text-laundry-gray-100 ">
        {isMobile ? (
          <div className="">
            <div className={`${STYLE_SPACE_SECTION_HIW(language)} mb-4`}>
              <img src="/images/customize.png" className={STYLE_IMG_MB_HIW} />
              <div>
                <div
                  className={
                    language === "TH"
                      ? STYLE_BODY_1_TEXT_LG_TH
                      : STYLE_BODY_1_TEXT_LG
                  }
                >
                  {TEXT_CHOOSE_AND_CUSTOMIZE[language]}
                </div>
                {language === "EN" && (
                  <div className={`${STYLE_BODY_4_REGULAR(language)} pt-4`}>
                    {TEXT_ALL_CHOOSE_1[language]}
                  </div>
                )}
                {language === "TH" && (
                  <div className={`${STYLE_BODY_4_REGULAR(language)} pt-4`}>
                    คุณสามารถเลือกและเพิ่มบริการซักผ้าและทำความสะอาดรองเท้าของเราตามความต้องการแบบครบวงจร
                    นอกจากนี้เราขอแนะนำบริการส่งน้ำดื่มแบบขวดเมื่อส่งคืน
                    <span>ออเดอร์ให้คุณ</span>
                  </div>
                )}
              </div>
            </div>
            <div className={`${STYLE_SPACE_SECTION_HIW(language)} mb-7`}>
              <div>
                <div
                  className={
                    language === "TH"
                      ? STYLE_BODY_1_TEXT_LG_TH
                      : STYLE_BODY_1_TEXT_LG
                  }
                >
                  {TEXT_WE_TAKE_CARE[language]}
                </div>

                {/* {language === "EN" && (
                  <div className={`${STYLE_BODY_4_REGULAR(language)} pt-4`}>
                    {TEXT_WE_TAKE_CARE_DESCRIPTION_ALL[language]}
                  </div>
                )}
                {language === "TH" && (
                  <div className={`${STYLE_BODY_4_REGULAR(language)} pt-4`}>
                    เราจะไปรับผ้าและรองเท้าของคุณตามที่อยู่ที่ระบุไว้
                    และรับประกันว่าจะส่งคืนภายใน 12:00 น. ของวันถัดไป
                    <span>
                      ด้วยการดูแลอย่างพิถีพิถันทั้งสะอาดและหอมสดชื่น
                      พร้อมทั้งมีบริการส่งคืนด่วนในวันเดียวกันด้วย
                    </span>
                  </div>
                )} */}
                <div className={`${STYLE_BODY_4_REGULAR(language)} pt-4`}>
                  {language === "TH" ? (
                    <React.Fragment>
                      เรา<span className="">รับประกัน</span>
                      ว่าจะส่งคืนทุกออเดอร์ในวันถัดไป:
                      เสื้อผ้าและเครื่องนอนภายใน {RETURN_TIME}:00 น.
                      รองเท้าหรือออเดอร์รวมผ้ากับรองเท้าภายใน{" "}
                      {RETURN_SHOSE_TIME}:00 น. สะดวกและรวดเร็ว!
                      <span className=""> บริการไร้การสัมผัส</span>
                      ของเราช่วยคุณประหยัดเวลา -
                      คุณไม่ต้องรอการรับส่งคืนออเดอร์เลย!
                    </React.Fragment>
                  ) : (
                    `We GUARANTEE next-day return for all orders: Laundry by ${RETURN_TIME}:00 noon, shoes or combined shoes & laundry orders by ${RETURN_SHOSE_TIME}:00 - fast & easy! Our service is fully CONTACTLESS to save your valuable time - you never need to wait for us, neither for pick up nor for return!`
                  )}
                </div>
              </div>
              <img
                src="/images/takecare.png"
                className={`w-img_howitwork_mb h-img_howitwork_mb mx-auto ${
                  language === "TH" ? "mt-[40px] md:mt-0" : "mt-[65px] md:mt-0"
                }`}
              />
            </div>
            <div className={`flex gap-4  pl-4 pt-4 pb-4`}>
              <img
                src="/images/convenient.png"
                className={`w-img_howitwork_mb h-img_howitwork_mb mt-[40px] md:mt-0 -ml-1 mr-1`}
              />
              <div>
                <div
                  className={`${
                    language === "TH"
                      ? STYLE_BODY_1_TEXT_LG_TH
                      : STYLE_BODY_1_TEXT_LG
                  } flex`}
                >
                  <div>{TEXT_EASY[language]}</div>
                  <div> {TEXT_CONVENIENT[language]}</div>
                </div>
                <div className={`${STYLE_BODY_4_REGULAR(language)} pt-4`}>
                  {TEXT_EASY_AND_CONVENIENT_ALL[language]}
                  <span>{TEXT_EASIER_AND_MORE_CONVENIENT[language]}</span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <React.Fragment>
            {img?.map((row, index) => {
              return (
                <div className=" text-center p-4 ">
                  <img
                    src={row?.img}
                    className="  md:w-40 xl:w-img_howitwork mx-auto"
                  />
                  <div
                    className={`${
                      language === "TH"
                        ? "  md:text-xl-th xl:text-2xl-th "
                        : "  md:text-xl xl:text-2xl "
                    } font-bold text-laudry-gray-100 leading-6.5 py-4`}
                  >
                    {row?.title}
                  </div>
                  <div
                    className={`${
                      language === "TH"
                        ? "text-xs-th md:text-sm-th "
                        : "text-xs md:text-sm"
                    } mx-auto leading-6`}
                  >
                    <div>{row?.description1}</div>
                    <div>{row?.description2}</div>
                    <div>{row?.description3}</div>
                    <div>{row?.description4}</div>
                    <div>{row?.description5}</div>
                    <div>{row?.description6}</div>
                  </div>
                </div>
              );
            })}
          </React.Fragment>
        )}
      </div>
      <div className={STYLE_BUTTON_HIW}>
        <BlueButton
          className={`${STYLE_BUTTON_BLUE(language)}`}
          onClick={() => {
            navigate("/OurServices");
          }}
          title={TEXT_CREATE_ORDER[language]}
        />
      </div>
    </div>
  );
});
export default HomeHowItWorks;
